var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicpenBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magicpen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0054 9.05544C13.6711 9.1595 13.3109 9.30756 12.9555 9.51804C12.1449 9.99822 11.3906 10.7863 11.0138 12.0372C10.6378 10.7798 9.88246 9.98995 9.06953 9.51038C8.71111 9.29893 8.34771 9.15124 8.0111 9.04816C8.33982 8.94555 8.69347 8.80028 9.04267 8.59477C9.85716 8.11543 10.616 7.32553 10.9937 6.06706C11.3717 7.32565 12.1311 8.11568 12.9476 8.59504C13.3058 8.80532 13.6688 8.95251 14.0054 9.05544Z",
    fill: "#035FC4",
    stroke: "#035FC4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.41081 4.01455C5.89578 4.31725 5.4232 4.84479 5.25837 5.72524C5.09827 4.83414 4.62684 4.30095 4.10962 3.99563C3.79012 3.80703 3.46335 3.71108 3.20304 3.66243C3.4609 3.61334 3.78465 3.5175 4.10192 3.33104C4.62963 3.02089 5.11276 2.47469 5.26597 1.55468C5.41918 2.47469 5.90231 3.02089 6.43002 3.33104C6.76725 3.52923 7.1118 3.62504 7.37677 3.67115C7.10937 3.71595 6.75625 3.81153 6.41081 4.01455Z",
    fill: "#035FC4",
    stroke: "#035FC4",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.89868 12.6616C1.57919 12.473 1.25241 12.3771 0.992097 12.3284C1.24996 12.2794 1.57371 12.1835 1.89098 11.9971C2.41869 11.6869 2.90182 11.1407 3.05503 10.2207C3.20824 11.1407 3.69137 11.6869 4.21908 11.9971C4.55631 12.1952 4.90086 12.2911 5.16583 12.3372C4.89843 12.382 4.54531 12.4775 4.19987 12.6806C3.68484 12.9833 3.21227 13.5108 3.04743 14.3913C2.88734 13.5002 2.4159 12.967 1.89868 12.6616Z",
    fill: "#035FC4",
    stroke: "#035FC4",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpenBlue);
export default __webpack_public_path__ + "static/media/magicpenBlue.86e27a2820b6bf33e904cd2c9434313e.svg";
export { ForwardRef as ReactComponent };